import uniqBy from 'lodash.uniqby';

import {
  TARGETS_SELECT,
  TARGETS_DESELECT,
  TARGETS_RESET,
} from './multiTargetSelectionActions';

export const initialState = {
  selectedTargets: [],
};

const multiTargetSelection = (state = initialState, action = {}) => {
  switch (action.type) {
    case TARGETS_RESET:
      return {
        ...initialState,
      };
    case TARGETS_SELECT:
      return {
        ...state,
        selectedTargets: uniqBy(
          [...state.selectedTargets, ...action.targets],
          'id',
        ),
      };
    case TARGETS_DESELECT:
      return {
        ...state,
        selectedTargets: state.selectedTargets.filter(
          target => !action.targets.map(({ id }) => id).includes(target.id),
        ),
      };
    default:
      return state;
  }
};

export default multiTargetSelection;
